module.exports = __webpack_public_path__ + "static/media/pixel_logo_6.a23297ef.png";